import React from 'react';
import styled from 'styled-components';

function Group({children}) {
  children = React.Children.toArray(children);
  return children.map((child, i) => <AvatarContainer key={i}>{child}</AvatarContainer>);
}

const AvatarContainer = styled.div`
  display: inline-block;
  margin-right: -0.75rem;
`;

export default Group;